(function () {
    'use strict';

    angular.module("imApp").factory("productMoveChoicesService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductMoveChoices: function (parms) {
                return $ihttp.post({
                    method: 2891,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();